import { Amplify } from 'aws-amplify';
import { config } from './awsExports';
import { DEFAULT_DATA_REGION, DATA_REGION_STORAGE_KEY, isValidDataRegion } from './regions';

/**
 * Inject the currently selected data region as a header on every GraphQL
 * request (feature 021-china-account-access). The backend re-validates this
 * value against the caller's `china-access` group before honoring it.
 */
const graphql_headers = async () => {
  const stored = localStorage.getItem(DATA_REGION_STORAGE_KEY);
  const region = isValidDataRegion(stored) ? stored : DEFAULT_DATA_REGION;
  return { 'x-data-region': region };
};

Amplify.configure({ ...config, graphql_headers });
